import './preview.scss'

import React, { Component, useEffect, useState } from 'react'
import cx from 'classnames'
import { connect } from 'react-redux'

import loadSheet from '../../actionCreators/loadSheet'

import selectSheet from '../../actionCreators/selectSheet'

import Cell from './Cell.tsx'
import HeaderCell from './HeaderCell.tsx'
import HeaderFormat from './HeaderFormat.tsx'

import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc'
import styled from 'styled-components'
import SubmitForm from './SubmitForm.tsx'

import NoSpreadSheet from './NoSpreadSheet'
import Modal from 'live/components/ui/Modal'
import PerspectiveSelect from 'live/components/forms/ui/perspective-select'
import i18n from 'live/services/i18n'
import dismissModal from '../../actionCreators/dismissModal'
// @ts-ignore
import ActionToggle from 'live/components/ui/action-toggle'
import 'rc-menu/assets/index.css'
import { SheetData } from './previewTypes'

interface IProps {
    dismissModal: () => void
    match: object
    loadSheet: (uuid: string) => any
    eventType: string
    expand?: any
    expanded?: any
    fileName: string
    history: object
    isModel: boolean | undefined
    sheetData: SheetData[]
    preview: boolean
    selectSheet: (tab: number) => void
    selected: number
    updateErrorMessage: string
    updatedSuccessfully: boolean
    importing: any
    importedSuccessfully: boolean
    importErrorMessage: string
    uid: string
}

function Preview({
    dismissModal,
    match,
    loadSheet,
    fileName,
    eventType,
    history,
    isModel,
    preview,
    sheetData,
    selectSheet,
    selected,
    importedSuccessfully,
    updatedSuccessfully,
    importErrorMessage,
    updateErrorMessage,
    importing,
    uid
}: IProps): JSX.Element {
    const [selectedTab, setSelectedTab] = useState<number>(selected)
    const [perspective, setPerpective] = useState<number>(0)
    const [collectionName, setCollectionName] = useState<string>('')
    const [databaseName, setDatabaseName] = useState<string>('')
    const [dateReference, setDateReference] = useState<boolean>(false)
    const [skipRealtime, setSkiprealtime] = useState<boolean>(true)

    const handleHideAndClose = () => {
        setPerpective(0)
        setCollectionName('')
        setDatabaseName('')
        setDateReference(false)
        setSelectedTab(0)
        dismissModal()
    }

    useEffect(() => {
        const { params = {} } = match
        const actualUid = params.uid
        if (!!actualUid && actualUid !== uid) loadSheet(actualUid)
    }, [])

    const setPerspective = evt => {
        const perspectiveId = typeof evt.perspective.id == 'string' ? 0 : evt.perspective.id
        setPerpective(perspectiveId)
    }


    return (
        <Modal
            show={preview}
            onHide={() => {
                handleHideAndClose()
            }}
            onClose={() => {
                handleHideAndClose()
            }}
            className="modal-preview-spreadsheet"
        >
            <Modal.Header style={{ backgroundColor: 'var(--gray-0)' }} closeButton>
                <ModalTitleContainer>
                    <InputArea>
                        <label>Database Name</label>
                        <input
                            data-cy="input-database-name"
                            type="text"
                            value={databaseName}
                            onChange={ev => {
                                setDatabaseName(ev.target.value)
                            }}
                        />
                    </InputArea>

                    <ToggleArea>
                        <div data-cy="dateReference">
                            <ActionToggle
                                active={dateReference}
                                disabled={false}
                                onChange={() => setDateReference(!dateReference)}
                            />
                        </div>
                        <label>Enable date reference input</label>
                    </ToggleArea>
                    <ToggleArea>
                        <div data-cy="skiprealtime">
                            <ActionToggle
                                active={skipRealtime}
                                disabled={false}
                                onChange={() => setSkiprealtime(!skipRealtime)}
                            />
                        </div>
                        <label>Use skip realtime</label>
                    </ToggleArea>
                    <InputArea>
                        <label>Collection Name</label>
                        <input
                            data-cy="input-collection-name"
                            type="text"
                            value={collectionName}
                            onChange={ev => setCollectionName(String(ev?.target?.value).toLowerCase())}
                        />
                    </InputArea>

                    <InputArea>
                        <PerspectiveContainer>
                            <PerspectiveSelect 
                                name="perspective"
                                placeholder={i18n('select')}
                                label={i18n('perspective')}
                                showOptionAll={true}
                                apply={setPerspective}
                                hasFeedback
                            />
                        </PerspectiveContainer>
                    </InputArea>
                </ModalTitleContainer>
            </Modal.Header>
            {sheetData ? (
                <div className="sheet-preview">
                    <div className="sheet-stage">
                        <div className="shadow">
                            {sheetData
                                .filter((sheet, i) => i === selectedTab)
                                .map((sheet, i) => {
                                    return (
                                        <table className="sheet" key={i}>
                                            <thead>
                                                <tr>
                                                    <th className="no-border"></th>
                                                    {sheet.header.map((cell, cellId) => (
                                                        <HeaderCell
                                                            sheet={selectedTab}
                                                            {...cell}
                                                            key={cellId}
                                                            isKey={cell.isKey}
                                                            updatedSuccessfully={updatedSuccessfully}
                                                            isDisabled={cell.isDisabled}
                                                        />
                                                    ))}
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    {sheet.header.map((cell, cellId) => (
                                                        <HeaderFormat
                                                            sheet={selectedTab}
                                                            {...cell}
                                                            key={cellId}
                                                            outsideClickIgnoreClass="rc-menu-item"
                                                        />
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {sheet.rows.map((row, rowId) => (
                                                    <tr key={rowId}>
                                                        <td>{rowId + 1}</td>
                                                        {row.map((cell, cellId) => (
                                                            <Cell
                                                                key={cellId}
                                                                {...cell}
                                                                isDisabled={sheet.header[cellId].isDisabled}
                                                            />
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )
                                })}
                        </div>
                    </div>

                    <div className="preview-footer">
                        <SubmitForm
                            perspective={perspective}
                            sheetIndex={selectedTab}
                            sheetName={sheetData[selectedTab].sheetName}
                            header={sheetData[selectedTab].header}
                            fileName={fileName}
                            dateReference={dateReference}
                            eventType={collectionName}
                            databaseName={databaseName}
                            isModel={isModel}
                            skipRealtime={skipRealtime}
                            history={history}
                            showErrorModal={updatedSuccessfully === false || importedSuccessfully === false}
                            error={
                                updatedSuccessfully === false
                                    ? { message: updateErrorMessage, action: 'atualizar campos' }
                                    : importedSuccessfully === false
                                    ? { message: importErrorMessage, action: 'importar dados' }
                                    : null
                            }
                            importing={importing}
                            importedSuccessfully={importedSuccessfully}
                            handleHideAndClose={handleHideAndClose}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    background: 'var(--gray-0)',
                                    width: '44.5px',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRight: 'solid 2px var(--gray-300)',
                                    height: '40px'
                                }}
                            >
                                <i
                                    style={{
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontFamily: 'Font Awesome 5 Pro',
                                        fontStyle: 'normal',
                                        fontWeight: 'normal',
                                        fontSize: '14px',
                                        lineHeight: '16px'
                                    }}
                                    className="far fa-file-spreadsheet"
                                ></i>
                            </div>

                            <ul className="sheets">
                                {sheetData.map((e, i) => (
                                    <li
                                        key={e.sheetName}
                                        className={cx({ selected: i === selectedTab })}
                                        style={{
                                            cursor: 'default',
                                            outline: 'none'
                                        }}
                                        onClick={() => {
                                            selectSheet(i)
                                            setSelectedTab(i)
                                        }}
                                    >
                                        {e.sheetName}
                                    </li>
                                ))}
                            </ul>
                        </SubmitForm>
                    </div>
                </div>
            ) : (
                <div style={{ height: '100%', padding: '1px' }}>
                    {uid ? (
                        <div className="loading-spreadsheet-preview">
                            <i className="far fa-spinner fa-spin" />
                        </div>
                    ) : (
                        <NoSpreadSheet />
                    )}
                </div>
            )}
        </Modal>
    )
}

const ModalTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 100%;
`
const InputArea = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    label {
        white-space: nowrap;
        margin-right: 7px;

        &::after {
            content: ' *';
            color: red;
        }
    }
    input {
        width: 216px;
        /* max-width: 350px; */
    }
`

const ToggleArea = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-left: 7px;
    height: 100%;
    label {
        white-space: nowrap;
        margin-right: 7px;
        margin-left: 4px;
    }
    a {
        top: 0 !important;
    }
    div {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`
const PerspectiveContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    /* height: 100%; */

    & .live-select {
        display: flex;
        flex-direction: row;
        label {
            margin-right: 7px;
            height: min-content;
            align-self: center;
        }
    }
    & .form-group {
        margin: 0 !important;
    }
    & .Select-control {
        width: 200px;
        border: 3px solid red;
        background-color:green;
    }
`

const PerspectiveSelector = styled.div`
    /* display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center; */
    background-color:green;
    
`

function mapStateToProps({ sheet }) {
    const {
        uid,
        sheetData,
        selected,
        updatedSuccessfully,
        updateErrorMessage,
        importing,
        importedSuccessfully,
        importErrorMessage,
        preview
    } = sheet

    return {
        sheetData,
        uid,
        selected,
        updatedSuccessfully,
        updateErrorMessage,
        importing,
        importedSuccessfully,
        importErrorMessage,
        preview
    }
}

export default connect(mapStateToProps, { selectSheet, loadSheet, dismissModal })(Preview)
